
/*import React from "react";
import Card from "../components/Card";
import './Home.css';

import abstractImage from "../assets/images/home/webpage_home_abstarct.png";


const Home = () => {
    return (
        <div className="home-page">
            <h1> Welcome to Quipo</h1>
            <Card
                heading="Mission"
                body= {
                    <p className="special-text">
                        Empowering retailers with an all-in-one PoS and eCommerce platform.
                    </p>
                }
            />
        </div>

        
    );
};

export default Home;
*/

/* New Home Page*/
import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import StatsSection from "../components/StatsSection";
import './Home.css';

import customerImage from "../assets/images/home/Delivery.png";
import vendorImage from "../assets/images/home/HappyVendor.png";
import instantGratificationImage from "../assets/images/home/DeliveredToday1.png";
import communityShoppingImage from '../assets/images/home/CommunityShopping.png';
import seamlessShoppingImage from "../assets/images/home/inShop_Online6.png";
import PoSToolsImage from "../assets/images/home/PoS_Analytics6.png";
import shopLocalImage from "../assets/images/home/ShopLocal1.png";
import supportLocalEconomyImage from "../assets/images/home/SupportLocalBusiness3.png";
import personalizedConnectionsImage from "../assets/images/home/RecommendedForYou2.png";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const Home = () => {

    const [stats, setStats] = useState({
        products: 0,
        merchants: 0,
        customers: 0,
        orders: 0,
    });

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await fetch(`${API_URL}/fetch-HomeStats`);
                const data = await response.json();
                
                console.log("Fetched API response:", data); // Log API response in browser console
                
                setStats({
                    products: data.totalProducts || 0,
                    merchants: data.totalMerchants || 0,
                    customers: data.totalCustomers || 0,
                    orders: data.totalOrders || 0,
                });
        
                console.log("Updated state:", {
                    products: data.totalProducts || 0,
                    merchants: data.totalMerchants || 0,
                    customers: data.totalCustomers || 0,
                    orders: data.totalOrders || 0,
                });
                
            } catch (error) {
                console.error("Error fetching stats:", error);
            }
        };
        
        fetchStats();
        const interval = setInterval(fetchStats, 60000); // Refresh every minute
        return () => clearInterval(interval);
    }, []);



    return (
        <div className="home-page">
            <h1>Connecting Businesses, Communities, And Customers Through A Thriving Digital Ecosystem.</h1>

            <section className="card-section">
                <Card
                    heading="Our Mission"
                    body={
                        <p className="special-text">
                            Empowering merchants with cutting-edge tools to thrive in a competitive marketplace.
                        </p>
                    }
                />
            </section>

            {/*Live Stats Section  */}
            <StatsSection stats={stats} />

            <section className="card-section">
                <Card
                    heading="Discover the Benefits of Shopping and Selling with Quipo"
                    body={
                        <div>
                            <section className="key-features">
                                <div className="feature">
                                    <img src={customerImage} alt="Customer receiving a package" />
                                    <h2>Your Gateway to Local Discoveries</h2>
                                    <p>
                                        Find unique products and great deals from trusted local merchants. Enjoy personalized recommendations, exclusive community events, and faster delivery or pick-up options for added convenience.
                                    </p>
                                </div>
                                <div className="feature">
                                    <img src={vendorImage} alt="Merchant using dashboard" />
                                    <h2>Empowering Local Businesses to Thrive</h2>
                                    <p>
                                        Access cloud-based inventory management for walk-in and online customers. Utilize advanced marketing, analytics, and sales tools to expand your reach and grow your business.
                                    </p>
                                </div>
                            </section>
                        </div>
                    }
                />
            </section>

            <section className="card-section">

                <Card
                    heading="How Quipo Stands Out in the Market ?"
                    body={
                        <section className="additional-features">
                            <div className="feature">
                                <img src={instantGratificationImage} alt="Fast Delivery and Pickup" />
                                <h2>Instant Gratification</h2>
                                <p>
                                    Say goodbye to long wait times. With Quipo, enjoy same-day delivery or instant pick-up from your favorite local merchants.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={communityShoppingImage} alt="Where Shopping Meets Communit" />
                                <h2>Community-Driven Shopping</h2>
                                <p>
                                    Strengthen local economies by connecting merchants and customers. Our platform is built to support small businesses and foster vibrant communities.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={seamlessShoppingImage} alt="Seamless Transition of Shopping" />
                                <h2>The Best of Both Worlds</h2>
                                <p>
                                    Enjoy the convenience of online shopping while still supporting local merchants. Seamlessly transition between walk-in and online experiences.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={PoSToolsImage} alt="Powerful PoS tools for merchants" />
                                <h2>Powerful Tools for Merchants</h2>
                                <p>
                                    Access inventory management, marketing insights, and analytics to stay ahead of the curve and grow your business.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={shopLocalImage} alt="Shop Local Save Big" />
                                <h2>Shop Local, Save Big</h2>
                                <p>
                                    Direct connections with merchants mean faster transactions, no delays, and better deals—all while keeping money in the local economy.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={supportLocalEconomyImage} alt="Support Local Economy" />
                                <h2>Support Your Local Economy</h2>
                                <p>
                                    Every purchase on Quipo helps sustain local businesses and strengthens your community.
                                </p>
                            </div>
                            <div className="feature">
                                <img src={personalizedConnectionsImage} alt="Personalized Connections" />
                                <h2>Personalized Connections</h2>
                                <p>
                                    Build direct relationships with local merchants. Enjoy tailored recommendations and a more human touch in your shopping experience.
                                </p>
                            </div>
                        </section>
                    }
                />
            </section>
        </div>
    );
};

export default Home;
